import { IChannelsController, callEnabledGetter, callLineGetter, callStarted, channelDisconnect, dataToDisconnectChannel, dataToGetCallEnabled, dataToGetLines, dataToGetTwilioToken, dataToGetWhatsAppActive, dataToHangUpCall, dataToSendCallTemplate, dataToStartCall, dataToUpdateWhatsAppBusinessProfile, dataToUpdateWhatsAppBusinessProfilePhoto, dataTogGetWhatsAppBusinessProfile, templateCallSend, whatsappBusinessProfile } from '../domain/ChannelsController'

export default class ChannelsUseCases {
  static abort (controller: IChannelsController) : void {
    controller.abort()
  }

  static async disconnectChannel (controller: IChannelsController, data: dataToDisconnectChannel) : Promise<channelDisconnect> {
    return await controller.disconnectChannel(data)
  }

  static async getWhatsAppBusinessProfile (controller: IChannelsController, data: dataTogGetWhatsAppBusinessProfile) : Promise<whatsappBusinessProfile> {
    return await controller.getWhatsAppBusinessProfile(data)
  }

  static async updateWhatsAppBusinessProfile (controller: IChannelsController, data: dataToUpdateWhatsAppBusinessProfile) : Promise<whatsappBusinessProfile> {
    return await controller.updateWhatsAppBusinessProfile(data)
  }

  static async updateWhatsAppBusinessProfilePhoto (controller: IChannelsController, data: dataToUpdateWhatsAppBusinessProfilePhoto) : Promise<whatsappBusinessProfile> {
    return await controller.updateWhatsAppBusinessProfilePhoto(data)
  }

  static async getCallWhatsAppEnabled (controller: IChannelsController, data: dataToGetCallEnabled): Promise<callEnabledGetter> {
    return await controller.getCallWhatsAppEnabled(data)
  }

  static async sendCallTemplate (controller: IChannelsController, data: dataToSendCallTemplate): Promise<templateCallSend> {
    return await controller.sendCallTemplate(data)
  }

  static async startCall (controller: IChannelsController, data: dataToStartCall): Promise<callStarted> {
    return await controller.startCall(data)
  }

  static async hangUpCall (controller: IChannelsController, data: dataToHangUpCall): Promise<{ message?: string, status: boolean }> {
    return await controller.hangUpCall(data)
  }

  static async getWhatsAppActive (controller: IChannelsController, data: dataToGetWhatsAppActive): Promise<{ status: boolean, message?: string }> {
    return await controller.getWhatsAppActive(data)
  }

  static async getTwilioToken (controller: IChannelsController, data: dataToGetTwilioToken): Promise<{ status: boolean, token?: string }> {
    return await controller.getTwilioToken(data)
  }

  static async getAllCallLines (controller: IChannelsController, data: dataToGetLines): Promise<callLineGetter> {
    return await controller.getAllCallLines(data)
  }
}
